import ListingService from "@/services/listing.service";

const state = () => ({
  list: [],
  loading: false,
  error: null,
});

const mutations = {
  SET_LOADING(state, isLoading) {
    state.loading = isLoading;
  },
  SET_CANDIDATES(state, payload) {
    state.list = payload;
  },
  SET_ERROR(state, err) {
    state.error = err;
  },
};

const actions = {
  async fetchCandidates({ commit }, params = {}) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const res = await ListingService.getCandidates(params);

      // ← LOG THE WHOLE PAYLOAD HERE
      console.log("💾 [candidate] fetchCandidates response:", res);

      // assuming your data is in res.data.data
      commit("SET_CANDIDATES", res.data.data);
    } catch (err) {
      commit("SET_ERROR", err);
      console.error("❌ [candidate] fetchCandidates failed:", err);
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const getters = {
  allCandidates: (state) => state.list,
  isLoading: (state) => state.loading,
  fetchError: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
